import { withTranslation } from "react-i18next";

import React from 'react';
import { Footer } from '../Common/Footer';
import { DashboardHeader } from '../Common/DashboardHeader';
import ProductsUpload from '../../Models/ProductsUpload';
import { connect } from 'react-redux';
import { productUpload } from '../../Action/productUpload';
import { withRouter } from 'react-router';
import CKEditor from 'ckeditor4-react';
import SimpleReactValidator from 'simple-react-validator';
import axios from 'axios';
import { post } from 'axios';
import Files from 'react-files';
import { Header } from '../Common';
import ImageUploader from 'react-images-upload';
import Products from '../../Models/Products';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Resizer from 'react-image-file-resizer';
import Common from "../../Models/Common";

class ProductUploadEdit extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('10'))
            this.props.history.push('/login/seller');
        };

        this.state = {

            services: [
                {
                    serviceName: '',
                    price: '',
                }
            ],

            file: '', imagePreviewUrl: '',

            files: [],
            sellerId: '',
            _id: 1,
            firstTitle: '',
            secondTitle: '',
            description: '',
            servicePrice: '',
            autoPayment: '',
            expectedDelivary: '',
            delivaryFormat: '',
            numberOfOrders: '',
            acceptance: '',
            paidForService: '',
            affiliatorPromote: '',
            categories: [],
            subCategories: [],
            affiliatorCommission: [],
            subCategory: '',
            Category: '',
            // affCommission: '',
            affCommission: React.createRef(),
            includeTransaction: '',
            includeVat: true,
            selectedFile: null,
            singlePictureString: null,
            picture: [],
            img: [],
            file: null,
            file2: null,
            file3: null,
            file4: null,
            pictures: [],
            editor_msg: '',
            message: '',
            subCategoryName: '',
            products: [],
            multiples: [],
            flag: '',
            counter: '',
            selfaff: ''
        };
        // this.state.files[0]='';
        this.getCategories();
        this.getAffiliatorCommission();
        SimpleReactValidator.addLocale('klingon', {
            integer: `${this.props.t('11')}`,
            max: `:attribute :max ${this.props.t('5')} .`,
            required: ` :attribute ${this.props.t('64')}`,
            min: `:attribute :min ${this.props.t('6')}`,
        });
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: 'klingon',
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        Products.getAllProducts(this.props.location.state.id).then(res => {
            console.log(res.data.payload)
            this.setState({ products: res.data.payload })
            this.setState({ firstTitle: res.data.payload.title })
            this.setState({ secondTitle: res.data.payload.short_desc })
            // this.setState({ pictures: res.data.multiples })
            // this.setState({ counter: res.data.multiples.length })
            this.setState({ singleImagePicture: res.data.payload.image_name })
            this.setState({ singleImage: res.data.payload.img })
            this.setState({ expectedDelivary: res.data.payload.expected_delivery_days })
            this.setState({ sellerId: res.data.payload.seller_id })
            this.setState({ delivaryFormat: res.data.payload.delivery_format })
            this.setState({ IsDraft: res.data.payload.is_draft })
            this.setState({ numberOfOrders: res.data.payload.no_of_order_at_atime })
            this.setState({ affCommission: res.data.payload.affiliator_commission })
            this.setState({ editor_msg: res.data.payload.long_desc })
            this.setState({ acceptance: res.data.payload.is_estimate_or_customizable })
            this.setState({ subCategory: res.data.payload.sub_category_id })
            this.setState({ Category: res.data.payload.category_id })
            this.setState({ subCategoryName: res.data.payload.cat_name })
            if (res.data.payload.self_affiliate === 'YES') {
                this.setState({ selfaff: true })
            } else {
                this.setState({ selfaff: false })
            }
            if (res.data.payload.renewal_type === 1) {
                this.setState({ autoPayment: false })
            } else if (res.data.payload.renewal_type === 2) {
                this.setState({ autoPayment: true })
            }
            this.getPrice()
        })
        Products.getAllProducts(this.props.location.state.id).then(res => {
            res.data.multiples.map(res => {
                this.setState({ picture: res.image, img: res.img })
            })
        })
        this.getPictures()
    }
    getPictures() {
        Products.getAllProducts(this.props.location.state.id).then(res => {
            // res.data.multiples.push({
            //     img: res.data.payload.img,
            //     image: res.data.payload.image_name
            // })
            this.setState({
                pictures: res.data.multiples,
                counter: res.data.multiples.length
            })
        })

    }
    // onEditorChange(evt) {
    //     let pre = evt.editor.getData();
    //     let exp = /(\b(((https?|ftp|file|):\/\/)|www[.])[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    //     let refine = pre.replace(exp, '');
    //     let cleanText = refine.replace(/<\/?[^>]+(>|$)/g, "");
    //     this.setState({
    //         editor_msg: cleanText
    //     });
    // }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    onEditorChange(evt) {
        this.setState({
            editor_msg: evt.editor.getData()
        });
    }

    checkValue(a) {
        this.validator.showMessageFor(a)
        let data = {
            'name': this.state.firstTitle,
            'product_id': this.props.location.state.id
        }
        ProductsUpload.getTitle(data).then(res => {
            if (res.data.flag === 1) {
                alert(this.props.t('0'))
                this.state.firstTitle = ''
            } else {
                this.state.firstTitle = this.state.firstTitle
            }
        })
    }

    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }

    handleChange(e) {
        ProductsUpload.getSubCategory(e.target.value).then(res => {
            this.setState({
                subCategories: res.data.category_sub
            })
        })
    }

    getAffiliatorCommission() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ affiliatorCommission: res.data.aff_points })
        })
    }

    updateChangeDelivary(e) {
        this.setState({
            delivaryFormat: e.target.value,
        })
    }

    updateChange1(e) {
        this.setState({
            acceptance: e.target.value
        })
    }

    handleIsDraft() {
        this.setState({ IsDraft: 0 })
        return (
            <div>
                <Button className="btn  ml-5 mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this)}>{this.props.t('37')}</Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} className={this.props.className}>
                    <ModalHeader toggle={this.toggle.bind(this)}></ModalHeader>
                    <ModalBody>
                        {this.props.t('7')}
                            </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle.bind(this)}>{this.props.t('88')}</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    handlePublish() {
        this.setState({ IsDraft: 1 })
    }

    onChange(e) {
        let file = e.target.files[0];
        let reader = new FileReader();
        let fileSize = e.target.files[0].size / 1024 / 1024;
        // this.state.pictures=this.state.multiples
        var pictures = this.state.pictures;
        reader.onloadend = () => {
            if (fileSize <= 2) {
                pictures.push({      //multiple Image
                    id: pictures.length + 1,
                    file: file,
                    picture: '',
                    img: '',
                    imagePreviewUrl: reader.result
                });
            } else {
                alert(this.props.t('89')+' 20KB'+this.props.t('134')+'3MB '+this.props.t('21'))
            }
            // console.log(pictures)
            this.setState({
                pictures,
                counter: this.state.counter + 1
            })

        }
        reader.readAsDataURL(file)
    }

    onChange1(e) {
        let file = e.target.files[0];
        if (file != '' || file != undefined || file != null) {
            let fileSize = e.target.files[0].size / 1024 / 1024;
            let reader = new FileReader();
            if (fileSize <= 3) {
                reader.onloadend = () => {
                    this.setState({
                        file: file,
                        singleImagePicture: '',
                        singleImage: '',
                        imagePreviewUrl: reader.result
                    })
                }
                reader.readAsDataURL(file)
            } else {
                this.setState({
                    file: '',
                    singleImagePicture: '',
                    singleImage: this.state.singleImage,
                })
                alert(this.props.t('89')+' 20KB'+this.props.t('134')+'3MB '+this.props.t('21'))
            }
        }
    }

    updateChange(e) {
        this.setState({
            affCommission: e.target.value,
        })
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    // addMore() {
    //     this.setState(preState =>
    //         ({
    //             services: [...preState.services, {
    //                 serviceName: '',
    //                 price: ''
    //             }]
    //         })
    //     );
    // }

    // createUI() {
    //     return this.state.services.map((el, i) => (
    //         <div key={i} className="mt-2">
    //             <input placeholder="" name="serviceName" className="basic_input" value={el.serviceName || ''} onChange={this.handleChange.bind(this, i)} />
    //             <input type="number" placeholder="" name="price" className="basic_input ml-2" style={{ width: '10%' }} value={el.price || ''} onChange={this.handleChange.bind(this, i)} /> {this.props.t('136')}
    //             <button className="btn btn-sm btn-danger ml-2" onClick={this.removeClick.bind(this, i)} >remove</button>
    //         </div>
    //     ))
    // }

    // handleChange(i, e) {
    //     const { name, value } = e.target;
    //     let services = [...this.state.services];
    //     services[i] = { ...services[i], [name]: value };
    //     this.setState({ services });
    // }

    // removeClick(i) {
    //     let services = [...this.state.services];
    //     services.splice(i, 1);
    //     this.setState({ services });
    // }

    getPrice() {
        if (this.state.products.commission_in_ex_vat === 'EXCLUDE_VAT') {
            this.setState({ servicePrice: this.state.products.price_ex, includeVat: false })
        } else if (this.state.products.commission_in_ex_vat === 'INCLUDE_VAT') {
            this.setState({ servicePrice: this.state.products.price_inc, includeVat: true })
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            var logged_user = JSON.parse(window.localStorage.getItem('info'));
            if (this.state.id === 'undefined' || this.state.id === '' || this.state.id === null) {
                this.setState({ id: '' })
            }
            if (this.state.singleImage) {
                if (this.state.singleImage === undefined || this.state.singleImage === '' || this.state.singleImage === null) {
                    this.state.singlePictureString = '';
                }
                else {
                    this.state.singlePictureString = this.state.singleImagePicture;
                }
            }
            if (this.state.picture === 'undefined' || this.state.picture === '' || this.state.picture === null) {
                this.setState({ picture: '' })
            }

            if (this.state.IsDraft === 0) {
                const formData = new FormData();
                formData.append('id', this.props.location.state.id)
                formData.append('title', this.state.firstTitle)
                formData.append('single_picture', this.state.file)
                formData.append('single_picture_string', this.state.singlePictureString)
                this.state.pictures.map((file) => {
                    // console.log('file');
                    console.log(file);
                    formData.append('file[]', file.file);
                    formData.append('file_string[]', file.image);
                });
                // formData.append('file', this.state.pictures)
                // formData.append('services', JSON.stringify(this.state.services))
                formData.append('short_desc', this.state.secondTitle)
                formData.append('seller_id', this.state.sellerId)
                formData.append('price_int', this.state.servicePrice)
                formData.append('expected_delivery_days', this.state.expectedDelivary)
                formData.append('delivery_format', this.state.delivaryFormat)
                formData.append('no_of_order_at_atime', this.state.numberOfOrders)
                formData.append('sub_category_id', this.refs.subCategory.value)
                formData.append('category_id', this.refs.Category.value)
                formData.append('affiliator_commission', this.refs.affCommission.value)
                formData.append('commission_in_ex_vat', this.state.includeVat)
                // formData.append('paidForService', this.state.paidForService)
                // formData.append('is_to_be_affiliated', this.state.affiliatorPromote)
                formData.append('long_desc', this.state.editor_msg)
                formData.append('is_estimate_or_customizable', this.state.acceptance)
                formData.append('is_draft', this.state.IsDraft)
                formData.append('selfaff', this.state.selfaff)
                formData.append('autoPayment', this.state.autoPayment)
                // console.log(formData)
                // console.log(data)
                axios({
                    method: 'post',
                    // url: 'http://192.168.1.110/sharework_back_v2/public/backend/upload-product',
                    // url: 'https://sharework-admin.bitpeboot.com/backend/upload-product',
                    url:  Common.api + 'upload-product',
                    data: formData,
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                }).then(res => {
                    console.log(res.data.status)
                    if (res.data.status === 200) {
                        alert(this.props.t('12'))
                        window.scrollTo(0, 0)
                        this.props.history.push('/service-list');
                    }
                })
                    .catch(
                        console.log('asd')
                    )
            } else {
                this.props.history.push({
                    pathname: `/product-upload-confirm`,
                    state: {
                        id: this.props.location.state.id,
                        firstTitle: this.state.firstTitle,
                        singleImage: this.state.singleImage,
                        singleImagePicture: this.state.singleImagePicture,
                        singlePicture: this.state.file,
                        picture: this.state.pictures,
                        secondTitle: this.state.secondTitle,
                        seller_id: logged_user.id,
                        servicePrice: this.state.servicePrice,
                        expectedDelivary: this.state.expectedDelivary,
                        img: this.state.img,
                        delivaryFormat: this.state.delivaryFormat,
                        numberOfOrders: this.state.numberOfOrders,

                        subCategory: this.refs.subCategory.value,
                        Category: this.refs.Category.value,
                        affCommission: this.refs.affCommission.value,
                        includeVat: this.state.includeVat,
                        paidForService: this.state.paidForService,
                        affiliatorPromote: this.state.affiliatorPromote,
                        editor_msg: this.state.editor_msg,
                        IsDraft: this.state.IsDraft,
                        acceptance: this.state.acceptance,
                        selfaff: this.state.selfaff,
                        autoPayment: this.state.autoPayment,
                    }
                })
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }

        // this.props.productUpload(formData,config, this.props.history);
    }

    deleteImage(i) {
        let pictures = this.state.pictures;
        const removeIndex = pictures.findIndex(e => e.id === i);
        const filteredPictures = this.state.pictures.filter((e, index) => index !== removeIndex);
        this.setState({ pictures: filteredPictures, counter: this.state.counter - 1 })
    }

    imagePreview(x, image, id, i) {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            if (i < 3) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={Common.baseUrl+x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            } else if (i >= 3 && i <= 5) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={Common.baseUrl+x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            } else if (i >= 6 && i <= 8) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            }
            else if (i >= 9 && i <= 10) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            }
        } else if (isDesktop) {
            // console.log("iiiii: xxx", x);
            // console.log("iiiii: img", image);
            // console.log("iiiii: ", i);
            if (i < 5) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={Common.baseUrl+x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            } else if (i >= 5 && i <= 10) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={Common.baseUrl+x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            }
        }
    }

    singleImage() {
        let { imagePreviewUrl } = this.state;
        // console.log("stttaaee!!!!!!!!!!", this.state.singleImage);
        // console.log("stttaaee!!!!!!!!!!prevv", imagePreviewUrl);
        if (this.state.singleImage === null || this.state.singleImage === undefined || this.state.singleImage === '') {
            return (
                <div className="imgPreview">
                    <img src={imagePreviewUrl} />
                </div>
            )
        } else {
            return (<div className="imgPreview">
                <img src={Common.baseUrl+this.state.singleImage} />
            </div>)
        }
    }

    imgShow() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="row multiple_image_upload" style={{ marginLeft: '0px', width: '280px', marginTop: '7px', marginRight: '5px' }}>
                    <div className="imgPreview" style={{ marginTop: '0px' }}>
                        <div className="row multiple_image_upload" style={{ marginLeft: '0px', width: '280px', marginRight: '5px' }}>
                            {this.state.pictures.map((p, i) =>
                                this.imagePreview(p.img, p.imagePreviewUrl, p.id, i)
                            )}
                        </div>
                    </div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginTop: '10px' }}></div>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div className="row multiple_image_upload" style={{ marginLeft: '0px', width: '450px', marginTop: '8px', marginRight: '5px' }}>
                    <div className="imgPreview" style={{ marginTop: '0px' }}>
                        <div className="row multiple_image_upload" style={{ marginLeft: '0px', width: '450px', marginRight: '5px' }}>
                            {this.state.pictures.map((p, i) =>
                                this.imagePreview(p.img, p.imagePreviewUrl, p.id, i)
                            )}
                        </div>
                    </div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                </div>
            )
        }
    }

    image() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            if (this.state.counter < 10) {
                return (
                    <input type="file" className="catagory_select" style={{ width: "75%", marginLeft: '0px', border: '1px solid #cccccc' }} onChange={this.onChange.bind(this)} />
                )
            } else {
                return (
                    <div></div>
                )
            }
        } else {
            if (this.state.counter < 10) {
                return (
                    <input type="file" className="catagory_select" style={{ width: "75%", marginLeft: '0px', border: '0px solid #cccccc', padding: '5px 0px' }} onChange={this.onChange.bind(this)} />
                )
            } else {
                return (
                    <div></div>
                )
            }
        }
    }

    title() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            if (this.state.flag === 1) {
                return (
                    <div>
                        <input type="text" className="basic_input input_width_height1 p-2" value={this.state.firstTitle} onChange={this.updateValue.bind(this, 'firstTitle')} onBlur={this.checkValue.bind(this, 'firstTitle')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('73'), this.state.firstTitle, 'required|min:10|max:25')}</span>
                    </div>
                )
            } else {
                return (
                    <div>
                        <input type="text" className="basic_input input_width_height1 p-2" value={this.state.firstTitle} onChange={this.updateValue.bind(this, 'firstTitle')} onBlur={this.checkValue.bind(this, 'firstTitle')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('73'), this.state.firstTitle, 'required|min:10|max:25')}</span>
                    </div>
                )
            }
        }
        // for desktop view
        else if (isDesktop) {
            if (this.state.flag === 1) {
                return (
                    <div>
                        <input type="text" className="basic_input input_width_height1 p-2" value={this.state.firstTitle} onChange={this.updateValue.bind(this, 'firstTitle')} onBlur={this.checkValue.bind(this, 'firstTitle')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('73'), this.state.firstTitle, 'required|min:10|max:25')}</span>
                    </div>
                )
            } else {
                return (
                    <div>
                        <input type="text" className="basic_input input_width_height1 p-2" value={this.state.firstTitle} onChange={this.updateValue.bind(this, 'firstTitle')} onBlur={this.checkValue.bind(this, 'firstTitle')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('73'), this.state.firstTitle, 'required|min:10|max:25')}</span>
                    </div>
                )
            }
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;

        //for mobile view
        if (isMobile) {
            let { imagePreviewUrl } = this.state;
            let $imagePreview = null;
            if (imagePreviewUrl) {
                $imagePreview = (<img src={imagePreviewUrl} />)
            } else {
                $imagePreview = (<div className="previewText"> Image</div>)
            }
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="mt-5 mb-3 input_name big_font guide_text" style={{ fontSize: '20px' }}>
                            {this.props.t('13')}
                                 </div>
                        <form onSubmit={this.handleSubmit.bind(this)}>
                            <div className="row form-group">
                                <div className="col-md-1"></div>
                                <div className="col-md-10">
                                    <div className="childs">
                                        <div className=" ">
                                            <h2>{this.state.message}</h2>
                                        </div>
                                        <div style={{ display: "none" }}>
                                            <div className="field_text_width">
                                                <span className="common_text_bold">{this.props.t('65')}</span><br />
                                                <span className="mandatory_alert font_12" >* {this.props.t('101')}</span>
                                            </div>
                                            <div className="field_width">
                                                <select className="cat_drop catagory_select" ref="Category" onChange={this.handleChange.bind(this)} value={this.state.Category}>
                                                    <option value=""> {this.props.t('23')}</option>
                                                    {this.state.categories.map(rp =>
                                                        <option value={rp.id} key={rp.id} >
                                                            {rp.cat_name}
                                                        </option>
                                                    )}
                                                </select>
                                                <select className="cat_drop catagory_select ml-2" ref="subCategory" value={this.state.subCategory} >
                                                    <option value={this.state.subCategory}>{this.state.subCategoryName}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div>&nbsp;</div>
                                        <div>
                                            <span className="common_text_bold">{this.props.t('24')}</span><br />
                                            <span className="mandatory_alert font_12">* {this.props.t('101')} </span> <span className="font_12">(10~25{this.props.t('91')})</span><br />
                                        </div>
                                        <div className="">
                                            {this.title()}
                                        </div>
                                        <div>&nbsp;</div>
                                        <div style={{ width: "100%" }}>
                                            <span className="common_text_bold">{this.props.t('38')}</span><br />
                                            <span className="mandatory_alert font_12">* {this.props.t('101')}</span> <span className="font_12">(15~30{this.props.t('91')})</span><br />
                                        </div>
                                        <div className="">
                                            <input type="text" className="catch_copy_input p-2" value={this.state.secondTitle} onChange={this.updateValue.bind(this, 'secondTitle')} onBlur={() => this.validator.showMessageFor('secondTitle')} /><br />
                                            <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message(this.props.t('38'), this.state.secondTitle, 'required|min:15|max:30')}</span>
                                        </div>
                                        <div>&nbsp;</div>
                                        <div className="field_text_width" style={{ width: "100%" }}>
                                            <span className="common_text_bold" >{this.props.t('52')}</span><br />
                                            <span className="mandatory_alert font_12">* {this.props.t('101')}</span> <span className="font_12">(1~5000{this.props.t('91')})</span>
                                        </div>
                                        <div className="field_width">
                                            <CKEditor
                                                data={this.state.editor_msg}
                                                onChange={this.onEditorChange.bind(this)}
                                                onBlur={() => this.validator.showMessageFor('editor_msg')}
                                                config={{
                                                    removePlugins: [
                                                        ['link']
                                                    ]
                                                }}
                                            />
                                            {this.validator.message(this.props.t('52'), this.state.editor_msg, 'required|min:1|max:5000')}
                                        </div>
                                    </div>
                                    <div className="" style={{ paddingLeft: '4%' }}>
                                        <div className="">
                                            <div className="field_text_width" style={{ width: "100%" }}>
                                                <span className="common_text_bold">{this.props.t('8')} </span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('101')}</span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('89')} 20KB{this.props.t('134')}3MB {this.props.t('21')}</span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('66')} JPEG, JPG, PNG, GIF {this.props.t('106')}</span><br />
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width" style={{ height: '104px' }}>
                                                <input type="file" className="catagory_select" style={{ width: "55%", marginBottom: '7px', marginLeft: '0px', border: '1px solid #cccccc' }} onChange={this.onChange1.bind(this)} />

                                                {this.singleImage()}

                                            </div>
                                            {/* <div>&nbsp;</div> */}
                                        </div>
                                        <div className="">
                                            <div className="field_text_width" style={{ width: '100%' }}>
                                                <span className="common_text_bold">{this.props.t('107')} </span><br />
                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('101')}</span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('89')} 20KB{this.props.t('134')}3MB {this.props.t('21')}</span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('66')} JPEG, JPG, PNG, GIF {this.props.t('106')}</span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('110')}10{this.props.t('1')}</span><br />
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width" style={{ height: 'auto' }}>
                                                {this.image()}
                                                {this.imgShow($imagePreview)}
                                            </div>
                                        </div>
                                        <div>&nbsp;</div>
                                        <div>
                                            <div className="field_text_width">
                                                <span className="common_text_bold">{this.props.t('54')}</span><br />
                                                <span className="mandatory_alert" style={{ fontSize: '12px' }}>* {this.props.t('101')}</span>
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '39px' }}>
                                                    <div className="" style={{ height: '39px' }}>
                                                        <input type="text" className="basic_input input_width_height2 p-2 " style={{ width: "100%" }} value={this.state.servicePrice} onChange={this.updateValue.bind(this, 'servicePrice')} onBlur={() => this.validator.showMessageFor('servicePrice')}></input> &nbsp;
                                                    </div>
                                                    &nbsp;<span className="my-auto">{this.props.t('136')} </span>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <div style={{ marginTop: '14px' }}>
                                                        <input type="checkbox" checked={this.state.autoPayment} onChange={this.updateValue.bind(this, 'autoPayment')} />&nbsp;&nbsp;
                                                    </div>
                                                    <div class="my-auto">
                                                        {this.props.t('77')}
                                                    </div>
                                                    <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('52'), this.state.servicePrice, 'required|integer')}</span>
                                                </div>
                                            </div>
                                            <span className="field_width">(20%{this.props.t('15')})</span>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div >
                                            <div className="field_text_width" style={{ width: '100%' }}>
                                                <span className="common_text_bold">{this.props.t('16')}</span><br />
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">

                                                <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '30px' }}>
                                                    <div className="" style={{ height: '30px' }}>
                                                        <select className="cat_drop mr-2 catagory_select" style={{ width: '100%' }} ref='affCommission' onBlur={() => this.validator.showMessageFor('affCommission')} value={this.state.affCommission} onChange={this.updateChange.bind(this)} >
                                                            <option value="" >{this.props.t('23')} </option>
                                                            {this.state.affiliatorCommission.map(rp =>
                                                                <option value={rp.id} key={rp.id}>
                                                                    {rp.point_value}
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>&nbsp;&nbsp;
                                                    <span className="my-auto">%</span>

                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <div style={{ marginTop: '9px' }}>
                                                        <input type="checkbox" checked={this.state.selfaff} onChange={this.updateValue.bind(this, 'selfaff')} />&nbsp;&nbsp;
                                                    </div>
                                                    <div class="my-auto">
                                                        {this.props.t('56')}
                                                    </div>

                                                    <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('16'), this.state.affCommission, 'required')}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="field_text_width" style={{ width: '100%' }}>
                                                <span className="common_text_bold">{this.props.t('78')}</span><br />
                                                <span className="mandatory_alert">* {this.props.t('101')}</span>
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <select className="cat_drop catagory_select" onChange={this.updateChangeDelivary.bind(this)} value={this.state.delivaryFormat} onBlur={() => this.validator.showMessageFor('delivaryFormat')}>
                                                    <option value="">{this.props.t('23')}</option>
                                                    <option value="video">{this.props.t('113')}</option>
                                                    <option value="pdf">PDF</option>
                                                    <option value="audio">{this.props.t('114')}</option>
                                                    <option value="chat">{this.props.t('79')}</option>
                                                </select>
                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('78'), this.state.delivaryFormat, 'required')}</span>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="field_text_width" style={{ width: '100%' }}>
                                                <span className="common_text_bold">{this.props.t('40')}</span><br />
                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('101')}</span>
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <input type="text" className="basic_input input_width_height2 p-2" value={this.state.expectedDelivary} onChange={this.updateValue.bind(this, 'expectedDelivary')} onBlur={() => this.validator.showMessageFor('expectedDelivary')} /> {this.props.t('140')}
                                                            {this.validator.message(this.props.t('40'), this.state.expectedDelivary, 'required|integer')}
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="field_text_width" style={{ width: '100%' }}>
                                                <span className="common_text_bold"> {this.props.t('42')}  </span><br />
                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('101')}</span>
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <input type="text" className="basic_input input_width_height2 p-2" value={this.state.numberOfOrders} onChange={this.updateValue.bind(this, 'numberOfOrders')} onBlur={() => this.validator.showMessageFor('numberOfOrders')} />&nbsp;{this.props.t('141')}&nbsp;
                                                            <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message(this.props.t('42'), this.state.numberOfOrders, 'required|integer')}</span>
                                            </div>
                                        </div>

                                        {/* <tr>
                                                        <td className="field_text_width">
                                                            <span className="common_text_bold">Add More services Services</span><br />
                                                        </td>
                                                        <td className="width_5"></td>
                                                        <td>{this.createUI()}
                                                            <div>
                                                                <button className="btn btn-sm btn-info mt-2" onClick={this.addMore.bind(this)}>add more</button>
                                                            </div>
                                                        </td>
                                                    </tr> */}
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="field_text_width" style={{ width: '100%' }}>
                                                <span className="common_text_bold"> {this.props.t('2')}</span>
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <select className="cat_drop catagory_select" onChange={this.updateChange1.bind(this)} value={this.state.acceptance} >
                                                    <option value="">{this.props.t('23')} </option>
                                                    <option value="YES">{this.props.t('68')} </option>
                                                    <option value="NO">{this.props.t('44')} </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        {/* <tr>
                                                        <td className="field_text_width">
                                                            <span className="common_text_bold">Paid for Service</span>
                                                        </td>
                                                        <td className="width_5"></td>
                                                        <td className="field_width">
                                                            <input type="checkbox" name="" value={this.state.paidForService} onChange={this.updateValue.bind(this, 'paidForService')} />  paid for service  <br />
                                                        </td>
                                                    </tr> */}
                                        <div>
                                            <div></div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <span className="">
                                                    <button type="submit" onClick={this.handleIsDraft.bind(this)} className="btn btn-secondary product_upload_buttons" style={{ width: '125px' }}>{this.props.t('57')}</button>
                                                </span>
                                                <span className="ml-2">
                                                    <button type="submit" onClick={this.handlePublish.bind(this)} className="btn  product_upload_buttons" style={{ width: '125px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >{this.props.t('81')}</button>
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            <div colSpan="3">&nbsp;</div>
                                        </div>
                                        {/* <tr>
                                                    <td></td>
                                                    <td colSpan="2" >
                                                        <span className="blue_text ml-5"><u>Delete Draft</u></span>
                                                    </td>
                                                </tr> */}
                                    </div>
                                    <div>&nbsp;</div>
                                </div>
                                <div className="col-md-1"></div>

                            </div>
                        </form>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            let { imagePreviewUrl } = this.state;
            let $imagePreview = null;
            if (imagePreviewUrl) {
                $imagePreview = (<img src={imagePreviewUrl} />)
            } else {
                $imagePreview = (<div className="previewText"> Image</div>)
            }
            return (
                <div  className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="mt-5 mb-3 input_name big_font guide_text" style={{ marginLeft: '130px' }}>
                                    {this.props.t('13')}
                                </div>
                                <form onSubmit={this.handleSubmit.bind(this)}>
                                    <div className="row form-group">
                                        <div className="col-md-1"></div>
                                        <div className="col-md-10">
                                            <div className="childs">
                                                <div className=" ">
                                                    <h2>{this.state.message}</h2>
                                                </div>
                                                <div style={{ display: "none" }}>
                                                    <div className="field_text_width">
                                                        <span className="common_text_bold">{this.props.t('65')}</span><br />
                                                        <span className="mandatory_alert font_12" >* {this.props.t('101')}</span>
                                                    </div>
                                                    <div className="field_width">
                                                        {/* <div onSubmit={this.sendCategories.bind(this)} >  */}
                                                        <select className="cat_drop" ref="Category" onChange={this.handleChange.bind(this)} value={this.state.Category}>
                                                            <option value=""> {this.props.t('23')}</option>
                                                            {this.state.categories.map(rp =>
                                                                <option value={rp.id} key={rp.id} >
                                                                    {rp.cat_name}
                                                                </option>
                                                            )}
                                                        </select>
                                                        <select className="cat_drop ml-2" ref="subCategory" value={this.state.subCategory} >
                                                            <option value={this.state.subCategory}>{this.state.subCategoryName}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div>&nbsp;</div>
                                                <div>
                                                    <span className="common_text_bold">{this.props.t('24')}</span><br />
                                                    <span className="mandatory_alert font_12">* {this.props.t('101')} </span> <span className="font_12">(10~25{this.props.t('91')})</span><br />
                                                </div>
                                                <div className="">
                                                    {this.title()}
                                                </div>
                                                <div>&nbsp;</div>
                                                <div>
                                                    <span className="common_text_bold">{this.props.t('38')}</span><br />
                                                    <span className="mandatory_alert font_12">* {this.props.t('101')}</span> <span className="font_12">(15~30{this.props.t('91')})</span><br />
                                                </div>
                                                <div className="">
                                                    <input type="text" className="catch_copy_input p-2" value={this.state.secondTitle} onChange={this.updateValue.bind(this, 'secondTitle')} onBlur={() => this.validator.showMessageFor('secondTitle')} /><br />
                                                    <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message(this.props.t('38'), this.state.secondTitle, 'required|min:15|max:30')}</span>
                                                </div>
                                                <div>&nbsp;</div>
                                                <div className="field_text_width">
                                                    <span className="common_text_bold" >{this.props.t('52')}</span><br />
                                                    <span className="mandatory_alert font_12">* {this.props.t('101')}</span> <span className="font_12">(1~5000{this.props.t('91')})</span>
                                                </div>
                                                <div className="field_width">
                                                    <CKEditor
                                                        data={this.state.editor_msg}
                                                        onChange={this.onEditorChange.bind(this)}
                                                        onBlur={() => this.validator.showMessageFor('editor_msg')}
                                                        config={{
                                                            removePlugins: [
                                                                ['link']
                                                            ]
                                                        }}
                                                    />
                                                    {this.validator.message(this.props.t('52'), this.state.editor_msg, 'required|min:1|max:5000')}
                                                </div>
                                            </div>
                                            <div className="" style={{ paddingLeft: '4%' }}>
                                                <table>
                                                    <tbody>
                                                        <tr className="">
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">{this.props.t('8')} </span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('101')}</span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('89')} 20KB{this.props.t('134')}3MB {this.props.t('21')}</span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('66')} JPEG, JPG, PNG, GIF {this.props.t('106')}</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width" style={{ height: '104px' }}>
                                                                <input type="file" className="mb-2" onChange={this.onChange1.bind(this)} />

                                                                {this.singleImage()}

                                                            </td>
                                                            <div>&nbsp;</div>
                                                        </tr>
                                                        <tr className="">
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">{this.props.t('107')} </span><br />
                                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('101')}</span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('89')} 20KB{this.props.t('134')}3MB {this.props.t('21')}</span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('66')} JPEG, JPG, PNG, GIF {this.props.t('106')}</span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('110')}10{this.props.t('1')}</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width" style={{ height: '104px' }}>
                                                                {this.image()}
                                                                {/* <input type="file" className="" onChange={this.onChange.bind(this)} /> */}
                                                                {this.imgShow($imagePreview)}
                                                                {/* <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('Image', this.state.file, 'required|Image')}</span> */}

                                                            </td>
                                                            <div>&nbsp;</div>
                                                        </tr>
                                                        <div>&nbsp;</div>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">{this.props.t('54')}</span><br />
                                                                <span className="mandatory_alert" style={{ fontSize: '12px' }}>* {this.props.t('101')}</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width my-auto" style={{ verticalAlign: 'middle' }}>
                                                                <input type="text" className="basic_input input_width_height2 p-2" value={this.state.servicePrice} onChange={this.updateValue.bind(this, 'servicePrice')} onBlur={() => this.validator.showMessageFor('servicePrice')}></input> &nbsp;
                                                                     &nbsp;<span>{this.props.t('136')}  (20%{this.props.t('15')})</span>
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                <input type="checkbox" checked={this.state.autoPayment} onChange={this.updateValue.bind(this, 'autoPayment')} />&nbsp;&nbsp;
                                                                    {this.props.t('77')}
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('52'), this.state.servicePrice, 'required|integer')}</span>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr style={{ height: '39px' }}>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">{this.props.t('16')}</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <select className="cat_drop mr-2" ref='affCommission' onBlur={() => this.validator.showMessageFor('affCommission')} value={this.state.affCommission} onChange={this.updateChange.bind(this)} >
                                                                    <option value="" >{this.props.t('23')} </option>
                                                                    {this.state.affiliatorCommission.map(rp =>
                                                                        <option value={rp.id} key={rp.id}>
                                                                            {rp.point_value}
                                                                        </option>
                                                                    )}
                                                                </select>
                                                                %
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                {console.log(this.state.selfaff)}
                                                                <input type="checkbox" checked={this.state.selfaff} onChange={this.updateValue.bind(this, 'selfaff')} />&nbsp;&nbsp;
                                                                {this.props.t('56')}
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('16'), this.state.affCommission, 'required')}</span>
                                                        </td>
                                                        </tr>
                                                        {/* <tr style={{ height: '39px' }}>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">{this.props.t('83')}</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <input type="checkbox" checked={this.state.selfaff} onChange={this.updateValue.bind(this, 'selfaff')} />&nbsp;&nbsp;
                                                                {this.props.t('128')}
                                                        </td>
                                                        </tr> */}
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">{this.props.t('78')}</span><br />
                                                                <span className="mandatory_alert">* {this.props.t('101')}</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <select className="cat_drop" onChange={this.updateChangeDelivary.bind(this)} value={this.state.delivaryFormat} onBlur={() => this.validator.showMessageFor('delivaryFormat')}>
                                                                    <option value="">{this.props.t('23')}</option>
                                                                    <option value="video">{this.props.t('113')}</option>
                                                                    <option value="pdf">PDF</option>
                                                                    <option value="audio">{this.props.t('114')}</option>
                                                                    <option value="chat">{this.props.t('79')}</option>
                                                                </select>
                                                                {/* <input type="text" className="basic_input input_width_height2" value={this.state.delivaryFormat} onChange={this.updateValue.bind(this, 'delivaryFormat')} onBlur={() => this.validator.showMessageFor('delivaryFormat')} /> <br /> */}
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('78'), this.state.delivaryFormat, 'required')}</span>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">{this.props.t('40')}</span><br />
                                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('101')}</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <input type="text" className="basic_input input_width_height2 p-2" value={this.state.expectedDelivary} onChange={this.updateValue.bind(this, 'expectedDelivary')} onBlur={() => this.validator.showMessageFor('expectedDelivary')} /> {this.props.t('140')}
                                                                    {this.validator.message(this.props.t('40'), this.state.expectedDelivary, 'required|integer')}
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold"> {this.props.t('42')}  </span><br />
                                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('101')}</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <input type="text" className="basic_input input_width_height2 p-2" value={this.state.numberOfOrders} onChange={this.updateValue.bind(this, 'numberOfOrders')} onBlur={() => this.validator.showMessageFor('numberOfOrders')} />&nbsp;{this.props.t('141')}&nbsp;
                                                                <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message(this.props.t('42'), this.state.numberOfOrders, 'required|integer')}</span>
                                                            </td>
                                                        </tr>


                                                        {/* <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">Add More services Services</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td>{this.createUI()}
                                                                <div>
                                                                    <button className="btn btn-sm btn-info mt-2" onClick={this.addMore.bind(this)}>add more</button>
                                                                </div>
                                                            </td>
                                                        </tr> */}
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold"> {this.props.t('2')}</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <select className="cat_drop" onChange={this.updateChange1.bind(this)} value={this.state.acceptance} >
                                                                    <option value="">{this.props.t('23')} </option>
                                                                    <option value="YES">{this.props.t('68')} </option>
                                                                    <option value="NO">{this.props.t('44')} </option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        {/* <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">Paid for Service</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <input type="checkbox" name="" value={this.state.paidForService} onChange={this.updateValue.bind(this, 'paidForService')} />  paid for service  <br />
                                                            </td>
                                                        </tr> */}
                                                        <tr><td>&nbsp;</td></tr>

                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td></td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <span className="mr-5">
                                                                    {/* <Link to={'#'}> */}
                                                                    <button type="submit" onClick={this.handleIsDraft.bind(this)} className="btn btn-secondary product_upload_buttons" style={{ width: '125px' }}>{this.props.t('57')}</button>
                                                                    {/* </Link> */}
                                                                </span>
                                                                <span className="ml-5">
                                                                    <button type="submit" onClick={this.handlePublish.bind(this)} className="btn  product_upload_buttons" style={{ width: '125px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >{this.props.t('81')}</button>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="3">&nbsp;</td>
                                                        </tr>
                                                        {/* <tr>
                                                                <td></td>
                                                                <td colSpan="2" >
                                                                    <span className="blue_text ml-5"><u>Delete Draft</u></span>
                                                                </td>
                                                            </tr> */}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div>&nbsp;</div>
                                        </div>
                                        <div className="col-md-1"></div>

                                    </div>
                                </form>
                            </div>
                            {/* )} */}
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
const mapStateToProps = (state) => ({
    productUpload: state.productUpload,
    errors: state.errors,
    categories: state.categories,
});

// ProductUploadEdit = connect(mapStateToProps, { productUpload })(withRouter(ProductUpload));

export { ProductUploadEdit }


 ProductUploadEdit = withTranslation('src_Components_ProductUpload_ProductUploadEdit')(ProductUploadEdit);
